module.exports = __webpack_public_path__ + "img/bolts.131ee978.png";